"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWrap = exports.Relative = exports.RichTextWrap = exports.ActionButton = exports.StyledControlsImg = exports.StyledImg = exports.InfoWrapper = exports.HeroWrapper = exports.CSS_VARIABLES = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.CSS_VARIABLES = {
    border: '--hero-view-border',
};
exports.HeroWrapper = app_1.styled.div `
  --hero-view-border: 1px solid ${(theme) => theme.stroke};
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  @media ${app_1.notDesktop} {
    grid-template-columns: minmax(0, 1fr);
  }
  border: var(${exports.CSS_VARIABLES.border});
  border-top: 0;
  > div > button {
    border-left: var(${exports.CSS_VARIABLES.border});
    border-bottom: var(${exports.CSS_VARIABLES.border});
    > svg {
      color: ${(theme) => theme.colors.primary};
    }
  }
  > div > div > span,
  h2 {
    border-right: var(${exports.CSS_VARIABLES.border});
    border-bottom: var(${exports.CSS_VARIABLES.border});
  }
`;
exports.InfoWrapper = app_1.styled.div `
  flex: 1;
  max-height: 50rem;
  overflow-x: hidden;
  overflow-y: auto;
  border-left: 1px solid ${(theme) => theme.stroke};
  padding: ${(theme) => theme.spacing.medium};
  padding-left: ${(theme) => theme.spacing.small};
  padding-right: ${(theme) => theme.spacing.small};
  padding-bottom: 0;
  padding-top: ${(theme, { $price }) => $price ? theme.spacing.extraSmall : theme.spacing.medium};
  margin-top: 0 !important;

  @media ${app_1.notDesktop} {
    padding-right: ${(theme) => theme.spacing.small};
  }
  @media ${app_1.mobile} {
    max-height: unset;
  }
`;
exports.StyledImg = (0, app_1.styled)(app_1.Image) `
  height: 100%;
  aspect-ratio: ${(_, { $ratio }) => $ratio};
  width: unset;
`;
exports.StyledControlsImg = app_1.styled.img `
  width: 100%;
  height: auto;
  max-width: 13rem;
  max-height: 13rem;
  object-fit: cover;
`;
exports.ActionButton = (0, app_1.styled)(ui_1.Button) `
  width: 100%;
  text-align: center;
`;
exports.RichTextWrap = app_1.styled.div `
  * {
    font-size: 0.875rem;
    letter-spacing: 0.025rem;
    line-height: 1.5rem;
    font-family: ${(theme) => theme.font};
    text-decoration: none;
    user-select: none;
  }
  h1,
  h2,
  h3 {
    font-size: 1.2rem;
    line-height: 2rem;
    margin-top: ${(theme) => theme.spacing.small};
  }

  color: ${(theme) => theme.colors.secondary};
  ${(_, { $contactMail }) => $contactMail
    ? (0, app_1.css) `
          min-height: 80%;
          margin-bottom: ${(theme) => theme.spacing.small};
        `
    : (0, app_1.css) `
          flex: 1;
        `}
  li {
    color: ${(theme) => theme.colors.secondary};
    font-weight: 400;
    list-style: none;
    line-height: 1.5rem;
  }
  ul {
    margin-top: 0;
    padding: 0;
  }
`;
exports.Relative = app_1.styled.div `
  position: relative;
  min-height: ${(theme) => `calc(100% - ${theme.spacing.medium} - ${theme.spacing.small} - 2.25rem)`};
`;
exports.ButtonWrap = app_1.styled.div `
  position: sticky;
  bottom: 0;
  width: 100%;
  margin: ${(theme) => theme.spacing.small} 0;
`;
